import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
//configs
import { MENUS } from 'configs/page';
//hooks
import useIsMountedRef from 'hooks/useIsMountedRef';
import useLeftMenu from 'hooks/useLeftMenu';
//layouts, views
import LoggedInLayout from 'layouts/LoggedInLayout';
//components
import InsightCampaigns from 'components/InsightCampaigns';
import InsightsReferral from 'components/InsightsReferral';

const Insights = (props) => {
    const isMountedRef = useIsMountedRef();
    const [leftMenu, setLeftMenu] = useLeftMenu();
    const [tabIndex, setTabIndex] = useState(1);

    useEffect(() => {
        if (leftMenu.value !== "INSIGHTS" && isMountedRef.current)
            setLeftMenu(MENUS.find(menu => menu.value === "INSIGHTS"));
    }, [leftMenu, setLeftMenu, isMountedRef]);

    return (
        <LoggedInLayout {...props} pageTitle="Insights">

            <div className={classNames("section", "my-compaign", "card-group")}>
                <div className="tab">
                    <div className="tab-header">
                        <ul>
                            <li className={classNames({ on: tabIndex === 1 })} onClick={() => setTabIndex(1)}>Campaign</li>
                            <li className={classNames({ on: tabIndex === 3 })} onClick={() => setTabIndex(3)}>Referrals</li>
                        </ul>
                    </div>
                    <div className="tab-content">
                        <div className={classNames("content", { on: tabIndex === 1 })}>
                            <InsightCampaigns />
                        </div>
                        <div className={classNames("content", { on: tabIndex === 3 })}>
                            <InsightsReferral />
                        </div>
                    </div>
                </div>
            </div>
        </LoggedInLayout>
    );
}

export default Insights;
